module.exports = __webpack_public_path__ + "static/media/avatar.0a755562.jpg";